import React from "react";
import { useForm } from "react-hook-form";
import "./auth.css";
import {
  useForgetPasswordMutation,
  useLoginMutation,
  useResetPasswordMutation,
} from "../../store/api/authApi";
import { setCredentials } from "../../store/slices/authSlice";
import { useDispatch } from "react-redux";
import InlineLoaderComponent from "../../components/common/InlineLoaderComponent";
import InlineMessageComponent from "../../components/common/InlineMessageComponent";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import styles from "./ResetPassword.module.css";
import BannerHeader from "../../components/BannerHeader/BannerHeader";
const ResetPassword = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onChange",
  });
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token"); // ?name=John → "John"
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [
    resetPassword,
    { isLoading: resetInprogress, data: resetData, error: errorInReset },
  ] = useResetPasswordMutation();
  const newPassword = watch("newPassword");
  const handleLogin = async (fdata) => {
    let formData = { ...fdata };
    delete formData.confirmPassword;
    try {
      const response = await resetPassword({ ...formData, token }).unwrap();
      if (!response?.isError) {
        toast.success(response.message);
        navigate("/login");
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("Reset failed:", err);
    }
  };
  return (
    <>
      <BannerHeader />
      <div className={`${styles.mainContainer} container`}>
        <section className={styles.content}>
          <div className={styles.resetPasswordHeader}>
            <h1 className="heading">Reset Password</h1>
            <p className="subheading">Please enter your new password.</p>
          </div>
          <div
            className={
              styles.resetPasswordBox + " login-registration-container"
            }
          >
            <InlineMessageComponent
              type={"error"}
              message={errorInReset?.data?.message}
            />
            <form
              onSubmit={handleSubmit(handleLogin)}
              className="signup-login-form  "
            >
              <div className="form-group">
                <label>Password*</label>
                <input
                  className="form-password"
                  type="password"
                  {...register("newPassword", {
                    required: "Password is required",
                    minLength: {
                      value: 6,
                      message: "Password must be at least 6 characters",
                    },
                  })}
                />
                {errors.newPassword && (
                  <span className="error-message">
                    {errors.newPassword.message}
                  </span>
                )}
              </div>

              <div className="form-group">
                <label>Confirm Password*</label>
                <input
                  className="form-password"
                  type="password"
                  {...register("confirmPassword", {
                    required: "Please confirm your password",
                    validate: (value) =>
                      value === newPassword || "Passwords do not match",
                  })}
                />
                {errors.confirmPassword && (
                  <span className="error-message">
                    {errors.confirmPassword.message}
                  </span>
                )}
              </div>

              <button type="submit" className="submit-button">
                Reset Password {resetInprogress && <InlineLoaderComponent />}
              </button>
            </form>
          </div>
        </section>
      </div>
    </>
  );
};

export default ResetPassword;
